export default {
    getBlockedUsers(state) {
        return state.blockedUsers;
    },
}